/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-13 16:28:18
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-08-16 11:54:21
 * @Description: 上传帮助方法
 * @FilePath: /hsylc2021/src/components/form/Uploader/utils.js
 */
import ACCEPT_TYPES from './acceptTypes';
import ROLES from '../../../utils/roles';
import { Api, Codes } from '../../../api';
import { buildOssPublicUrl, finalizeOssUploadKey } from '../../../utils/ossFileUrl';
const ERR_MSG = {
  CREDENTIAL_ERR: '获取签名错误，请稍后再试！',
  OSS_ERR: '链接OSS服务器失败，请稍后再试！',
  SIZE_ERR: '文件过大，超过{0}',
  SYS_ERR: '系统错误，请联系管理员！'
};
const SIZE_TYPE = {
  MB: 'mb',
  GB: 'gb',
  KB: 'kb',
  B: 'b'
};
/**
 * @description 获取accept type字符串
 * @function getAcceptTypeStr
 * @param {Array} arr 支持文件类型数组
 * @return {String} accept type字符串
 */
const getAcceptTypeStr = arr => {
  let ret = '';
  if (arr && arr.length) {
    arr.forEach(item => {
      let key = item.toLocaleUpperCase();
      if (ACCEPT_TYPES[key]) {
        ret += ACCEPT_TYPES[key] + ', ';
      }
    });
  }
  if (ret && ret.length) {
    ret = ret.substring(0, ret.length - 2);
  }
  return ret;
};
/**
 * @description 获取数字签名
 * @function getCredential
 * @param {Object} file File
 * @param {String} type 文件类型
 * @param {String} fileName 文件名称
 * @param {Boolean} rename 是否重命名
 * @return {Object} 接口约定对象
 */
const getCredential = async (file, type, role = ROLES.STUDENT, fileName = '', rename = false) => {
  let ret = null;
  let res = {};
  let file_name = '';
  if (fileName) {
    file_name = fileName;
  } else {
    file_name = file.name;
  }
  const params = {
    file_name,
    type,
    file_size: file.size
  };
  if (rename) {
    params.rename = true;
  }
  switch (role) {
    case ROLES.STUDENT: {
      res = await Api.post.studentOSSCredential(params);
      break;
    }
    case ROLES.SL: {
      res = await Api.post.slOSSCredential(params);
      break;
    }
    case ROLES.TEACHER: {
      res = await Api.post.teacherOSSCredential(params);
      break;
    }
    default: {
      res = await Api.post.OSSCredential(params);
    }
  }
  if (res && res.status === Codes.SUCCESS) {
    ret = res;
  } else {
    ret = res || { status: Codes.ERR_MSG, msg: ERR_MSG.CREDENTIAL_ERR };
  }
  return ret;
};
/**
 * @description 检查文件大小
 * @function checkFileSize
 * @param {Object} file File
 * @param {Number} maxSize 最大大小
 * @param {String} sizeType 大小类型 b/kb/mb/gb 默认mb
 * @return {Object} 接口约定对象
 */
const checkFileSize = (file, maxSize = 0, sizeType = SIZE_TYPE.MB) => {
  let ret = { status: Codes.SUCCESS };
  if (file && maxSize) {
    let size = file.size;
    let maxBit = maxSize;
    switch (sizeType) {
      case SIZE_TYPE.KB:
        maxBit *= 1024;
        break;
      case SIZE_TYPE.MB:
        maxBit *= Math.pow(1024, 2);
        break;
      case SIZE_TYPE.GB: {
        maxBit *= Math.pow(1024, 3);
        break;
      }
    }
    if (size > maxBit) {
      ret.status = Codes.ERR_MSG;
      ret.msg = ERR_MSG.SIZE_ERR.replace(/{\d}/, `${maxSize}${sizeType.toLocaleUpperCase()}`);
    }
  }
  return ret;
};
/**
 * @description 上传文件请求
 * @function uploadFile
 * @param {Object} file File
 * @param {String} type 文件类型
 * @param {String} role 角色 default = ROLES.STUDENT
 * @param {String} fileName 文件名
 * @param {Boolean} rename 是否重命名 default = false
 * @param {String|Boolean} resetKey 是否重命名key 当rename为false时生效 default = false 当为true时，以filename为重命名数据，当为字符串时，自身则为重命名数据
 * @return {Object} 接口约定对象
 */
const uploadFile = async (file, type, size = 0, sizeType = SIZE_TYPE.MB, role = ROLES.STUDENT, fileName = '', rename = false, resetKey = false) => {
  let ret = checkFileSize(file, size, sizeType);
  if (ret.status === Codes.SUCCESS) {
    let credentialRes = await getCredential(file, type, role, fileName, rename);
    if (typeof resetKey === 'boolean' && resetKey && !rename) {
      let file_name = '';
      if (fileName) {
        file_name = fileName;
      } else {
        file_name = file.name;
      }
      credentialRes.data.key += `/${file_name}`;
    } else if (typeof resetKey === 'string' && resetKey && !rename) {
      let strs = credentialRes.data.key.split('.');
      credentialRes.data.key += `/${resetKey}.${strs[1]}`;
    }
    ret = { ...credentialRes };
    if (ret && ret.status === Codes.SUCCESS) {
      ret.data.key = finalizeOssUploadKey(ret.data.key);
      let res = await Api.postOSS(ret.data, file);
      if (res.status === Codes.SUCCESS) {
        ret.data = {
          url: buildOssPublicUrl(credentialRes.data.endpoint, credentialRes.data.key)
        };
      } else {
        ret.status = Codes.ERR_MSG;
        ret.msg = ERR_MSG.OSS_ERR;
      }
    } else {
      ret.msg = ERR_MSG.SYS_ERR;
    }
  }
  return ret;
};
export default {
  ERR_MSG,
  getAcceptTypeStr,
  uploadFile,
  checkFileSize
};
